import { GeneralStore } from 'mobx-stores/general-store'
import { StoreProductsTableStore, 
  ProductsShippingsStore, 
  ViewProductsPageStore, 
  ProductsSKUsStore, 
  ProductDetailsStore,
  ProductImagesStore,
  ProductsSKUTableStore
 } from 'mobx-stores/products'
import { OrdersTableStore, OrdersDetailsStore } from 'mobx-stores/orders'
import { routingStore } from 'mobx-stores/routing-store'
import {
  StoreAttributesStore,
  StoreShippingsStore,
  StoresMainStore,
  ViewStorePageStore
} from 'mobx-stores/stores'
import { UserStore } from 'mobx-stores/users'
import { StoresPublic } from 'mobx-stores/stores-public';
import { AccountStore, ActionHistoryStore, CartCheckoutStore, DepartmentsStore, ImagesStore, StatisticsStore, StatisticsTableStore } from 'mobx-stores'
import { NotificationsStore } from 'mobx-stores/notifications/notifications-store'

class RootStore {
  routingStore = routingStore
  generalStore = new GeneralStore(this)
  userStore = new UserStore(this)
  storesMainStore = new StoresMainStore(this)
  viewStorePageStore = new ViewStorePageStore(this)
  storeProductsTableStore = new StoreProductsTableStore(this)
  viewProductsPageStore = new ViewProductsPageStore(this)
  productsDetailsStore = new ProductDetailsStore(this);
  productsSKUsStore = new ProductsSKUsStore(this)
  productsImagesStore = new ProductImagesStore(this)
  productsShippingsStore = new ProductsShippingsStore(this)
  ordersStore = new OrdersTableStore(this)
  ordersDetailsStore = new OrdersDetailsStore(this)
  storeAttributesStore = new StoreAttributesStore(this)
  storeShippingsStore = new StoreShippingsStore(this)
  productsSKUTableStore = new ProductsSKUTableStore(this)
  storesPublic = new StoresPublic(this)
  accountStore = new AccountStore(this)
  cartCheckoutStore = new CartCheckoutStore(this)
  statisticsStore = new StatisticsStore(this)
  statisticsTableStore = new StatisticsTableStore(this)
  actionHistoryStore = new ActionHistoryStore(this)
  notificationsStore = new NotificationsStore(this)
  imagesStore = new ImagesStore(this)
  departmentsStore = new DepartmentsStore(this)
}
const rootStore = new RootStore();
export default rootStore;